import { render, staticRenderFns } from "./materiel-allocation-apply.vue?vue&type=template&id=c04ba83c"
import script from "./materiel-allocation-apply.vue?vue&type=script&lang=js"
export * from "./materiel-allocation-apply.vue?vue&type=script&lang=js"
import style0 from "./materiel-allocation-apply.vue?vue&type=style&index=0&id=c04ba83c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports